import { useRef } from 'react';

import { useSidebarScale } from './useSidebarScale';

/* Zones de la barre latérale (logo, navigation, pied) mesurées pour adapter l'échelle du menu à la
   hauteur de la fenêtre. */
export function useSidebarRefs({ profile, setNavBoxHeight, setNavScale, sidebarCollapsed }) {
  const navLogoRef = useRef(null);
  const navBottomRef = useRef(null);
  const navContentRef = useRef(null);
  useSidebarScale({
    navBottomRef,
    navContentRef,
    navLogoRef,
    profile,
    setNavBoxHeight,
    setNavScale,
    sidebarCollapsed,
  });
  return { navBottomRef, navContentRef, navLogoRef };
}
